export default Object.freeze({
  CreateRequest: 'create-request',
  ViewDetails: 'view-details',
  CancelRequest: 'cancel-request',
  CompleteRequestInformation: 'complete-request-information',
  ApproveRequest: 'approve-request',
  ExecuteTask: 'execute-task',
  SignDocument: 'sign-document',
  ReassignTask: 'reassign-task',
  MassRequestsApprove: 'mass-requests-approve',
  Export: 'export',
  MassRequestsReject: 'mass-requests-reject',
  EntityAdd: 'entity-add',
  EntityEdit: 'entity-edit',
  EntityDelete: 'entity-delete',
  EntityImport: 'entity-import',
  RejectRequest: 'reject-request',
  SetFavorite: 'set-favorite',
  VoidRequest: 'void-request',
  MassRequestsCancel: 'mass-requests-cancel',
  MassRequestsVoid: 'mass-requests-void',
  MassRequestsExecuteTask: 'mass-requests-execute-task',
  MassRequestsCompleteRequestInformation: 'mass-requests-complete-request-information',
  ActionCustomCommands: 'action-custom-commands',
});
